import { roundNumbers } from "../utils";

const getPredictionOutcomeDistribution = ({
  total_positive,
  total_negative,
}) => {
  const total = total_positive + total_negative;
  return [
    {
      name: "positive",
      value: roundNumbers(total_positive / total, 2) * 100,
      cellProps: { fill: "#6EE7B7" },
    },
    {
      name: "negative",
      value: roundNumbers(total_negative / total, 2) * 100,
      cellProps: { fill: "#FCA5A5" },
    },
  ];
};

const getOutOfRangeValuesDistribution = ({
  total_positive,
  total_negative,
  out_of_range_rows,
}) => {
  const total = total_positive + total_negative;
  return [
    {
      name: "In Range",
      value: roundNumbers((total - out_of_range_rows) / total, 2) * 100,
      cellProps: { fill: "#6EE7B7" },
    },
    {
      name: "Out Of Range",
      value: roundNumbers(out_of_range_rows / total, 2) * 100,
      cellProps: { fill: "#FCA5A5" },
    },
  ];
};

const getPositivePredictionConfidenceDistribution = ({
  confidence_distribution_for_positive_predictions,
}) => [
  ...(confidence_distribution_for_positive_predictions?.map((count, index) => ({
    name: index * 10,
    count,
  })) ?? []),
  { name: 100, count: 0 },
];

const getNegativePredictionConfidenceDistribution = ({
  confidence_distribution_for_negative_predictions,
}) => [
  ...(confidence_distribution_for_negative_predictions?.map((count, index) => ({
    name: index * 10,
    count,
  })) ?? []),
  { name: 100, count: 0 },
];

const getDistributionData = summary => ({
  predictionOutcome: getPredictionOutcomeDistribution(summary),
  outOfRange: getOutOfRangeValuesDistribution(summary),
  positiveDistribution: getPositivePredictionConfidenceDistribution(summary),
  negativeDistribution: getNegativePredictionConfidenceDistribution(summary),
});

export { getDistributionData };
